export enum OfferType {

  PROMOTION = 'promotion',
  VOUCHER = 'voucher',

}

export interface Offer {

  readonly id: number,
  readonly advertiserId: number,

  readonly type: OfferType,
  readonly campaign: string,

  readonly title: string,
  readonly description: string,
  readonly terms: string,
  readonly url: string,

  readonly voucherCode?: string,

  readonly createdAt: string,
  readonly startFrom: string,
  readonly endAfter: string,

}

export interface Offers {

  readonly offers: Offer[];

}
